const normalizeAttributeGroups = function normalizeAttributeGroups({ addOns, attributeGroups }) {
  if (attributeGroups && attributeGroups.storefrontAttributes) {
    const { storefrontAttributes } = attributeGroups;
    const attributes = {};

    attributes.addOns = addOns;

    Object.keys(storefrontAttributes).forEach((attribute) => {
      const { value } = storefrontAttributes[attribute];

      if (value) {
        attributes[attribute] = value[0] === 'Yes' || value[0] === true;
      }
    });

    return attributes;
  }

  return {};
};


export default normalizeAttributeGroups;
